export const NAVBAR_HEIGHT_PX = 60;

export const ACADEMIC_UPGRADE_RIBBON_HEIGHT_PX = 40;

export const DEFERRED_ACADEMIC_TRIAL_BANNER_HEIGHT_PX = 56;

export const LAYOUT_HEADER_OFFSET_CSS_VAR = '--layout-header-offset';

export const Z_INDEX_ACADEMIC_RIBBON = 980;

export const Z_INDEX_SITE_HEADER = 1000;

export const Z_INDEX_HOME_HEADER = 1001;

export const Z_INDEX_NAV_MEGA_PANEL = 1010;

export const Z_INDEX_NAV_MOBILE_BACKDROP = 1198;

export const Z_INDEX_NAV_MOBILE_DRAWER = 1199;
